import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import styles from "./ToolTip.module.scss";
import ChevronLeft from "../../../../assets/icons/chevron-left.svg";
import ChevronLeftActive from "../../../../assets/icons/chevron-left-active.svg";
import ChevronRight from "../../../../assets/icons/chevron-right.svg";
import { ToolTipClassNameMap, OnboardingSteps } from "../../../../constants";

const ToolTip = ({ closeOnboarding }) => {
  const { onboardingStep, prevOnboardingStep } = useSelector(
    (state) => state.filter
  );
  const { experiments } = useSelector((state) => state.view);
  const { bubbleUI } = experiments;
  const dispatch = useDispatch();
  const hasClickedLeft =
    prevOnboardingStep > onboardingStep && prevOnboardingStep !== 0;
  // Get the Title and Description for the bet shuffle from OnboardingSteps map in constants;
  const { title, description } = OnboardingSteps.find(
    (tip) => tip.step === onboardingStep
  );

  const handleLeftArrow = () => {
    if (onboardingStep > 1) {
      dispatch({
        type: "SET_ONBOARDING_STEP",
        payload: onboardingStep - 1,
      });
    }

    return null;
  };

  const handleRightArrow = () => {
    if (onboardingStep < 7) {
      dispatch({
        type: "SET_ONBOARDING_STEP",
        payload: onboardingStep + 1,
      });
    }
    if (onboardingStep === 7) {
      // Reset Step back to 0 and close
      dispatch({
        type: "SET_ONBOARDING_STEP",
        payload: 0,
      });
      closeOnboarding();
      // Set localStorage flag onboardingSeen so the user does not see the onboarding again after viewing
      // the first time unless they clear their localStorage
      localStorage.setItem("onboardingSeen", true);
      // remove the onboardingSkipped flag so the user is no longer prompted
      // to show the onboarding popup now they have completed the journey
      localStorage.removeItem("onboardingSkipped");
    }
    return null;
  };

  const handletoolTipClass = () => {
    if (onboardingStep === 0) {
      return "";
    }

    // If we return to the Form Onboarding Step (number 5) from SortBy Step (Number 6)
    // we set a different className to handle the reverse direction of the arrow animation.
    if (onboardingStep === 5 && hasClickedLeft && !bubbleUI) {
      return "toolTip--fromSortByToForm";
    }

    // If we return to the SelectionsHeader (number 1) from the Filters (number 2)
    // we set a different class to handle the reverse direction of the arrow animation
    if (onboardingStep === 1 && hasClickedLeft && !bubbleUI) {
      return "toolTip--fromFiltersToSelectionsHeader";
    }

    // If we return to the SelectionContainer (number 3) from the Stats Step (Number 4)
    // we set a different className to handle the reverse direction of the arrow animation.
    if (onboardingStep === 3 && hasClickedLeft && !bubbleUI) {
      return "toolTip--fromStatsToSelectionRow";
    }

    const toolTipClass = ToolTipClassNameMap.get(onboardingStep);
    if (bubbleUI) {
      return toolTipClass + "--bubbleJourney";
    }
    return toolTipClass;
  };

  return (
    <div
      data-testid={`tool-tip-${onboardingStep}`}
      className={`${styles.toolTip} ${styles[`${handletoolTipClass()}`]}`}
    >
      <div className={styles.toolTipTop}>
        <div>
          <div className={styles.toolTipNumber}>{onboardingStep} of 7</div>
          <div className={styles.toolTipTitle}>{title}</div>
        </div>
        <div className={styles.toolTipArrows}>
          <button
            type="button"
            className={styles["toolTipArrowButton--left"]}
            disabled={onboardingStep === 1}
            onClick={() => handleLeftArrow()}
          >
            <img
              src={onboardingStep === 1 ? ChevronLeft : ChevronLeftActive}
              alt="chevron left"
            />
          </button>
          <button
            type="button"
            className={`${styles.toolTipArrowButton} ${
              onboardingStep === 7 ? styles["toolTipArrowButton--finish"] : ""
            }`}
            onClick={() => handleRightArrow()}
          >
            {onboardingStep === 7 ? (
              "Finish"
            ) : (
              <img src={ChevronRight} alt="chevron right" />
            )}
          </button>
        </div>
      </div>
      <div className={styles.toolTipBottom}>{description}</div>
    </div>
  );
};

ToolTip.propTypes = {
  closeOnboarding: PropTypes.func,
};

export default ToolTip;
